<template>
  <ubi-page-container class="ContactsVisites" wide-main-content>

    <!-- Nouveau moteur de filtres API -->
    <ApiSearchForm
        business-domain="immo"
        route="contact/contacts-visites"
        :user-context="userContext"
        @search="handleSearchFromApi"
        @ready="handleSearchFormReady"
        hide-more-button
    />

    <ubi-panel v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
      <ubi-list-header slot="header"
                       :limits="limits"
                       :page.sync="page"
                       :limit.sync="limit"
                       :total="visites.totalItems"
                       :sort.sync="sort"
                       :sortProperties="sortProperties"
                       :defaultFilter="this.filter.preset"
                       @filter="doFilter"
      ></ubi-list-header>
      <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit" :total="visites.totalItems"></ubi-list-footer>
      <el-table ref="table" :data="visites.items">
        <el-table-column min-width="120">
          <template v-slot="{ row: visite }">
            <img width="80" v-if="visite.photoMiniature != null" alt="" :src="visite.photoMiniature" :srcset="visite.photoMiniature" />
            <div v-else style="text-align: center;">
              <ubi-icon class="no-photo" name="camera" size='60'/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dateVisite" :label="$t('contacts.visites.columnDateVisite')" min-width="250">
          <template v-slot="{ row: visite }">
            {{ visite.dateVisite }} {{ visite.horaireVisite }}
          </template>
        </el-table-column>
        <el-table-column prop="refAnnonce" :label="$t('contacts.visites.columnAdReference')" min-width="140">
          <template v-slot="{ row: visite }">
            <router-link :to="{ name: 'post-view', params: { post: visite.idAnnonce } }">
              {{ visite.refAnnonce }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnAdStatut')" min-width="200" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.etatAnnonce === 'A' ? $t('contacts.visites.adActive') : $t('contacts.visites.adInactive') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnJaugeVisite')" min-width="190" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.nbInscrit }} / {{ visite.nbPersonne }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnNbAttente')" min-width="180" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.nbFileAttente }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnListeCandidatsExport')" min-width="190" align="center">
          <template v-slot="{ row: visite }">
            <div v-if="visite.candidats && visite.candidats.length > 0">
              <download-excel :data="visite.candidats" :fields="jsonFields" :name="`candidats-visite-${visite.id}.xls`">
                <ubi-icon name="export" class="Route-icon" style="cursor: pointer;" />
              </download-excel>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '../../components/Panel'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { getVisites } from '@/services/visites.js'
import { mapMutations, mapState } from 'vuex'
import JsonExcel from 'vue-json-excel'
import Vue from 'vue'
import { getContactsAll } from '@/services/contacts'
import moment from 'moment/moment'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import UbiIcon from '@/components/Icon.vue'

export default {
  name: 'contacts-visites',
  components: {
    UbiIcon,
    UbiListFooter,
    UbiListHeader,
    UbiPageContainer,
    UbiPanel,
    ApiSearchForm
  },
  data () {
    return {
      visites: { items: [], totalItems: 0, totalPages: 0, currentPage: 1, perPage: 10 },
      loading: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      sortProperties: {
        '-DC': this.$t('general.sort.decreaseDate'),
        DC: this.$t('general.sort.increaseDate'),
        R: this.$t('general.sort.reference')
      },
      nbResults: 0,
      jsonFields: {
        Civilité: 'civilite',
        Prénom: 'prenom',
        Nom: 'nom',
        Email: 'email',
        Téléphone: 'telephone',
        'Statut visite': 'status'
      }
    }
  },
  beforeMount () {
    Vue.component('downloadExcel', JsonExcel)
  },
  mounted () {
    // Ne pas appeler fetchList() ici, ApiSearchForm le fera via handleSearchFormReady()
  },
  methods: {
    handleSearchFormReady () {
      console.log('✅ ContactsVisites - ApiSearchForm prêt')
    },

    handleSearchFromApi (filters) {
      console.log('🔍 ContactsVisites - Filtres reçus:', filters)

      const mappedFilters = {}

      if (filters.search !== undefined) {
        mappedFilters.search = filters.search || ''
      }

      console.log('📝 ContactsVisites - Filtres mappés:', mappedFilters)

      if (Object.keys(mappedFilters).length > 0) {
        this.addFilter(mappedFilters)
      }

      this.fetchList()
    },

    doFilter (preset) {
      this.setFilter({ preset: preset })
      this.setPage(1)
      this.setOffset(0)
      this.fetchList()
    },

    async fetchList () {
      this.loading = true
      const emptyVisites = { items: [], totalItems: 0, totalPages: 0, currentPage: 1, perPage: this.limit }
      try {
        const visitesFilters = {
          post: {
            reference: this.filter.search,
            advertiser: { id: this.user.advertiser }
          },
          withAds: true,
          page: this.page,
          size: this.limit
        }
        switch (this.filter.sort) {
          case '-DC':
            visitesFilters.sort = 'dateDebut'
            visitesFilters.direction = 'desc'
            break
          case 'DC':
            visitesFilters.sort = 'dateDebut'
            visitesFilters.direction = 'asc'
            break
          case 'R':
            visitesFilters.sort = 'refAnnonce'
            visitesFilters.direction = 'desc'
            break
          default:
            visitesFilters.sort = 'dateDebut'
            visitesFilters.direction = 'desc'
        }

        const dataVisites = await getVisites(visitesFilters)
        const visitesResponse = dataVisites && Array.isArray(dataVisites.items) ? dataVisites : emptyVisites
        this.setResults(visitesResponse)

        if (visitesResponse.items.length > 0) {
          visitesResponse.items.forEach((element) => {
            const dateDebut = new Date(element.dateDebut)
            element.dateVisite = moment.utc(dateDebut).format('DD/MM/YYYY')
            element.horaireVisite = moment.utc(dateDebut).format('HH:mm')
            let nbInscrit = 0
            let nbFileAttente = 0
            if (element.candidats && element.candidats.length > 0) {
              element.candidats.forEach(async (candidat) => {
                if (candidat.status === 'OUI') {
                  nbInscrit++
                } else if (candidat.status === 'FILE_ATTENTE') {
                  nbFileAttente++
                }
                const contactsFilters = {}
                contactsFilters.reference = element.refAnnonce
                contactsFilters.mail = candidat.email
                const dateBefore = moment().subtract(6, 'months')
                contactsFilters.beforeContacts = moment(dateBefore).format('YYYY-MM-DD')
                const contacts = await getContactsAll(contactsFilters)
                if (contacts && contacts.contact_mailtracking && contacts.contact_mailtracking.length > 0) {
                  const contact = contacts.contact_mailtracking[0]
                  candidat.civilite = contact.civilite
                  candidat.prenom = contact.prenom
                  candidat.nom = contact.nom
                  candidat.telephone = contact.telephone
                }
              })
            }
            element.nbInscrit = nbInscrit
            element.nbFileAttente = nbFileAttente
          })
        }

        this.visites = visitesResponse
      } catch (error) {
        console.error('Erreur lors du chargement des visites:', error)
        this.setResults(emptyVisites)
        this.visites = emptyVisites
      } finally {
        this.loading = false
      }
    },

    ...mapMutations('contactsListVisites', [
      'setPage',
      'setLimit',
      'setSort',
      'setResults',
      'setOffset',
      'setSearch',
      'resetFilter',
      'setFilter',
      'addFilter'
    ])
  },
  computed: {
    ...mapState('contactsListVisites', ['filter']),
    user () {
      return this.$store.getters.getUser
    },
    userContext () {
      return {
        metier: this.user.metier,
        advertiser: this.user.advertiser
      }
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.ContactsVisites {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }
}
</style>
